
import s0 from '~/.nuxt/gb-cms/sections/Acknowledgments'
import s1 from '~/.nuxt/gb-cms/sections/BlogHero'
import s2 from '~/.nuxt/gb-cms/sections/CenteredSlide'
import s3 from '~/.nuxt/gb-cms/sections/ContactForm'
import s4 from '~/.nuxt/gb-cms/sections/CustomForm'
import s5 from '~/.nuxt/gb-cms/sections/DownloadSingle'
import s6 from '~/.nuxt/gb-cms/sections/Downloads'
import s7 from '~/.nuxt/gb-cms/sections/Faq'
import s8 from '~/.nuxt/gb-cms/sections/FaqHero'
import s9 from '~/.nuxt/gb-cms/sections/FaqTemplate'
import s10 from '~/.nuxt/gb-cms/sections/Features'
import s11 from '~/.nuxt/gb-cms/sections/FeaturesSlider'
import s12 from '~/.nuxt/gb-cms/sections/FeaturesSlider2'
import s13 from '~/.nuxt/gb-cms/sections/Feedback'
import s14 from '~/.nuxt/gb-cms/sections/FeedbackForm'
import s15 from '~/.nuxt/gb-cms/sections/GoToQuestionnaire'
import s16 from '~/.nuxt/gb-cms/sections/IconText'
import s17 from '~/.nuxt/gb-cms/sections/IconTextBlocks'
import s18 from '~/.nuxt/gb-cms/sections/IconsTextList'
import s19 from '~/.nuxt/gb-cms/sections/ImageText'
import s20 from '~/.nuxt/gb-cms/sections/ImageTextOffset'
import s21 from '~/.nuxt/gb-cms/sections/ImageTextSec'
import s22 from '~/.nuxt/gb-cms/sections/Info'
import s23 from '~/.nuxt/gb-cms/sections/Info2'
import s24 from '~/.nuxt/gb-cms/sections/InfoLinks'
import s25 from '~/.nuxt/gb-cms/sections/InfoPracing'
import s26 from '~/.nuxt/gb-cms/sections/Modules'
import s27 from '~/.nuxt/gb-cms/sections/News'
import s28 from '~/.nuxt/gb-cms/sections/Newsletter'
import s29 from '~/.nuxt/gb-cms/sections/Offices'
import s30 from '~/.nuxt/gb-cms/sections/PricingFaq'
import s31 from '~/.nuxt/gb-cms/sections/QuestionnaireSection'
import s32 from '~/.nuxt/gb-cms/sections/QuestionnaireSuccess'
import s33 from '~/.nuxt/gb-cms/sections/RelatedModules'
import s34 from '~/.nuxt/gb-cms/sections/RelatedPosts'
import s35 from '~/.nuxt/gb-cms/sections/Search'
import s36 from '~/.nuxt/gb-cms/sections/Solutions'
import s37 from '~/.nuxt/gb-cms/sections/SolutionsHero1'
import s38 from '~/.nuxt/gb-cms/sections/SolutionsHero2'
import s39 from '~/.nuxt/gb-cms/sections/Suitable'
import s40 from '~/.nuxt/gb-cms/sections/Suitable2'
import s41 from '~/.nuxt/gb-cms/sections/SupportArticles'
import s42 from '~/.nuxt/gb-cms/sections/SupportHero'
import s43 from '~/.nuxt/gb-cms/sections/SupportHeroDownloads'
import s44 from '~/.nuxt/gb-cms/sections/SupportHeroSearch'
import s45 from '~/.nuxt/gb-cms/sections/SupportHeroTutorials'
import s46 from '~/.nuxt/gb-cms/sections/Team'
import s47 from '~/.nuxt/gb-cms/sections/Testimonials'
import s48 from '~/.nuxt/gb-cms/sections/Text'
import s49 from '~/.nuxt/gb-cms/sections/TextImage'
import s50 from '~/.nuxt/gb-cms/sections/TextImageDouble'
import s51 from '~/.nuxt/gb-cms/sections/TextImageWide'
import s52 from '~/.nuxt/gb-cms/sections/TextTwoButtons'
import s53 from '~/.nuxt/gb-cms/sections/Tools'
import s54 from '~/.nuxt/gb-cms/sections/Touch'
import s55 from '~/.nuxt/gb-cms/sections/TryForFree'
import s56 from '~/.nuxt/gb-cms/sections/Tutorials'
import s57 from '~/.nuxt/gb-cms/sections/TwoButtonsSocialText'
import s58 from '~/.nuxt/gb-cms/sections/VerticalTabs'
import s59 from '~/.nuxt/gb-cms/sections/VerticalTabsFaq'
import s60 from '~/.nuxt/gb-cms/sections/Video'
import s61 from '~/.nuxt/gb-cms/sections/WorksSlider1'
import s62 from '~/.nuxt/gb-cms/sections/WorksSlider2'
import s63 from '~/.nuxt/gb-cms/sections/HelpdeskModules'
import s64 from '~/.nuxt/gb-cms/sections/Products'
import s65 from '~/.nuxt/gb-cms/sections/RightPlanBlueSection'
import s66 from '~/.nuxt/gb-cms/sections/AddOnPosibilities'

const sectionMapper = {
	'acknowledgments': s0,
	'blog-hero': s1,
	'centered-slide': s2,
	'contact-form': s3,
	'custom-form': s4,
	'download-single': s5,
	'downloads': s6,
	'faq': s7,
	'faq-hero': s8,
	'faq-template': s9,
	'features': s10,
	'features-slider': s11,
	'features-slider-2': s12,
	'feedback': s13,
	'feedback-form': s14,
	'go-to-questionnaire': s15,
	'icon-text': s16,
	'icon-text-blocks': s17,
	'icons-text-list': s18,
	'image-text': s19,
	'image-text-offset': s20,
	'image-text-sec': s21,
	'info': s22,
	'info-2': s23,
	'info-links': s24,
	'info-pracing': s25,
	'modules': s26,
	'news': s27,
	'newsletter': s28,
	'offices': s29,
	'pricing-faq': s30,
	'questionnaire-section': s31,
	'questionnaire-success': s32,
	'related-modules': s33,
	'related-posts': s34,
	'search': s35,
	'solutions': s36,
	'solutions-hero-1': s37,
	'solutions-hero-2': s38,
	'suitable': s39,
	'suitable-2': s40,
	'support-articles': s41,
	'support-hero': s42,
	'support-hero-downloads': s43,
	'support-hero-search': s44,
	'support-hero-tutorials': s45,
	'team': s46,
	'testimonials': s47,
	'text': s48,
	'text-image': s49,
	'text-image-double': s50,
	'text-image-wide': s51,
	'text-two-buttons': s52,
	'tools': s53,
	'touch': s54,
	'try-for-free': s55,
	'tutorials': s56,
	'two-buttons-social-text': s57,
	'vertical-tabs': s58,
	'vertical-tabs-faq': s59,
	'video': s60,
	'works-slider-1': s61,
	'works-slider-2': s62,
	'helpdesk-modules': s63,
	'products': s64,
	'right-plan-blue-section': s65,
	'add-on-posibilities': s66
}

export default sectionMapper
